import { STATE_KEY } from 'src/utils/consts'
import { getLocalStore } from 'src/utils'
import useCases from './use-cases'

export const initialState = {
  windowWidth: 10000,
  windowHeight: 10000,
  isDesktop: true,
  useCases: useCases,
  currentUseCase: null,
  shouldShowUseCases: false,
}

export const loadState = () => {
  try {
    return getLocalStore(STATE_KEY) || {}
  } catch (err) {
    return {}
  }
}

export default initialState
